export default {
  data() {
    return {
      redirectUri: window.location.pathname + window.location.search,
    }
  },
}
